import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  loading: false,
  error: false,
  submitted: false,
  errorMessage: "",
};
const submitUpdatedAddressReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SUBMIT_UPDATED_ADDRESS_STARTED:
      return updateObject(state, {
        loading: true,
        error: false,
        submitted: false,
        errorMessage: "",
      });
    case actionTypes.SUBMIT_UPDATED_ADDRESS_SUCCESS:
      return updateObject(state, {
        loading: false,
        error: false,
        submitted: true,
        errorMessage: "",
      });
    case actionTypes.SUBMIT_UPDATED_ADDRESS_FAILED:
      return updateObject(state, {
        loading: false,
        error: true,
        submitted: false,
        errorMessage: action.errorMessage,
      });
    case actionTypes.RESET_UPDATED_ADDRESS:
      return updateObject(state, {
        loading: false,
        error: false,
        submitted: false,
        errorMessage: "",
      });
    default:
      return state;
  }
};

export default submitUpdatedAddressReducer;
